import React, {
    useContext,
    useState,
    useEffect,
    useRef
} from 'react';
import { Navigate, Link } from "react-router";
import { useQuery, useMutation } from '@tanstack/react-query';

import { getCustomer } from "../router";

import * as UTILS from "../utils";
import * as QUERIES from "../query-functions";
import * as OPTIONS from "../option-fields";

import LoadingIndicator from '../components/loading-indicator';
import AccountNavigation from './account-navigation';
import LogoutButton from '../components/logout-button';
import UpsellBlock from '../components/upsell-block';
import CustomerMemberhips from './customer-memberships';

const getMatchingOffersByMembershipIds = (ids) => {
    const elements = OPTIONS.account.personalised_offers.offers;
    if (!elements) return;

    return Array.from(elements).filter(el =>
      ids.includes(el.getAttribute('personalised-offer'))
    );
}

const AccountMembership = () => {

    const { data: customer, isPending, isFetching } = getCustomer();

    const { 
        isPending: membershipsPending,
        isFetching: membershipsFetching,
        data: membershipsData,
    } = useQuery({
        queryKey: ['membershipsData'],
        queryFn: QUERIES.getMemberships,
        refetchOnWindowFocus: false,
        retry: false,
        staleTime: 86400000
    });

    const [personalisedOffers, setPersonalisedOffers] = useState(null);

    useEffect(() => {
        if (!customer || !membershipsData) return;

        const memberships = UTILS.getCustomerMembershipData(customer, membershipsData);
        const membership_ids = memberships.map((membership) => membership.id);
        const matching_offers = getMatchingOffersByMembershipIds(membership_ids);
        
        setPersonalisedOffers(matching_offers);

    }, [customer, membershipsData])

    return (
        <>
            <AccountNavigation />

            <div className='booking-pathway__container booking-pathway__account booking-pathway__account--memberships'>

                <div className='booking-pathway__main-content'>
                    <h1 className='booking-pathway__header'>Membership & offers</h1>

                    {customer.subscriptions?.length ?
                        <CustomerMemberhips />
                    :OPTIONS.account.membership_upsell.block ?
                        <div dangerouslySetInnerHTML={{__html: OPTIONS.account.membership_upsell.block.innerHTML}}></div>
                    :null
                    }

                    {personalisedOffers?.length ?
                        <div className='personalised-offers'>
                            <h2>Your personalised offers</h2>
                            {personalisedOffers.map((offer) =>
                                <div dangerouslySetInnerHTML={{__html : offer.innerHTML}}></div>
                            )}
                        </div>
                    :null}
                </div>

                <div className='booking-pathway__footer'>
                    <LogoutButton />

                    <UpsellBlock content={OPTIONS.account.orders_upsell} type="orders-upsell" />
                </div>

            </div>
        </>
    );
};

export default AccountMembership;
